<app-header [activeSite]="'forest'"></app-header>

<ion-content [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large">Forest</ion-title>
        </ion-toolbar>
    </ion-header>
    <div class="content">
        <app-plant-canvas *ngIf="plantData" [plantData]="plantData" [amount]="5"></app-plant-canvas>
    </div>
    <ion-fab vertical="bottom" horizontal="end" slot="fixed">
        <ion-fab-button>
            <ion-icon name="people"></ion-icon>
        </ion-fab-button>
        <ion-fab-list side="top">
            <ion-fab-button (click)="openChat()">
                <ion-icon name="chatbubble-ellipses"></ion-icon>
            </ion-fab-button>
            <ion-fab-button (click)="openCanvas()">
                <ion-icon name="brush"></ion-icon>
            </ion-fab-button>
        </ion-fab-list>
    </ion-fab>
</ion-content>
